<template>
  <VdTooltip :content="dynamicSegmentsName.join(', ')" :disabled="!hasMoreSegments">
    <section :class="$style.dynamicSegmentsWrapper">
      <div :class="$style.segmentsColumn">
        <div :class="$style.segmentList">
          <VdIcon store="fa" name="arrow-progress" />
          <div>
            <p>Dynamic</p>
            <div>
              <span v-for="(segment, index) in displayedSegments" :key="segment" :class="$style.segment">
                <span>{{ segment }}</span>
                <span v-if="hasMoreSegments && index === 1">...</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </VdTooltip>
</template>

<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { VdTooltip } from "@voodoo.io/voodoo-ui";
import { PropType, computed } from "vue";

const props = defineProps({
  dynamicSegmentsName: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const displayedSegments = computed(() => props.dynamicSegmentsName.slice(0, 2));
const hasMoreSegments = computed(() => props.dynamicSegmentsName.length > 2);
</script>

<style module lang="scss">
.dynamicSegmentsWrapper {
  display: flex;
  font-size: 10px;
  background-color: var(--vd-color-surface-100);
  border-radius: 16px;
  padding: 12px;
  margin-left: 8px;

  svg {
    margin-right: 0.5rem;
  }

  .segmentsColumn {
    display: flex;
    flex-direction: column;

    p {
      font-weight: 600;
      font-size: 10px;
      margin: 0;
      margin-bottom: 0;
    }

    .segment {
      white-space: nowrap;

      &:not(:last-of-type):after {
        content: ",";
        margin-right: size("XS");
      }
    }

    .segmentList {
      display: flex;
      align-items: center;
    }

    &:first-child {
      margin-right: 1rem;
    }
  }
}
</style>
